module.exports = __webpack_public_path__ + "img/5.9c32cd49.jpg";